import {
  IonButton,
  IonButtons,
  IonCard,
  IonContent,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonSpinner,
  IonText,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { documentTextOutline, personOutline, trashOutline } from "ionicons/icons";
import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../../../store/rootReducer";
import { selectDocumentTypesSelected } from "../../../store/MassNotification/selectors/selectDocumentTypesSelected";
import { setDeselectAll, setDeselectDocumentType } from "../../../store/MassNotification";
import { findTotalPeople } from "../../../store/MassNotification/actions/findTotalPeople";

const countStyle = {
  verticalAlign: "middle",
};

export const DocumentTypesSelected = () => {
  const dispatch = useDispatch();
  const selectedDocumentTypes = useSelector(
    (state: RootState) => state.massNotification.selectedDocumentTypes
  );
  const documentTypes = useSelector(selectDocumentTypesSelected);
  const findDocumentTypesStatus = useSelector(
    (state: RootState) => state.massNotification.findDocumentTypesStatus
  );

  return (
    <IonCard style={{ height: "75vh" }} class="ion-no-margin">
      <IonToolbar color="primary">
        <IonTitle size="small" style={{ fontWeight: 500 }}>
          Seleccionados ({selectedDocumentTypes.length})
        </IonTitle>
        <IonButtons slot="end">
          {!!selectedDocumentTypes.length && (
            <IonButton
              fill="solid"
              color="danger"
              onClick={() => {
                dispatch(setDeselectAll());
                dispatch(findTotalPeople());
              }}
              size="small"
            >
              <small>Quitar todos</small>
              <IonIcon icon={trashOutline} slot="end" />
            </IonButton>
          )}
        </IonButtons>
      </IonToolbar>
      <IonContent style={{ overlay: "scroll", height: "68vh" }}>
        <IonList>
          {findDocumentTypesStatus === "succeeded" &&
            documentTypes.map((item) => (
              <IonItem key={item.id}>
                <IonLabel className="ion-hide-md-up" text-wrap>
                  <h5 style={{ fontWeight: 700 }}>
                    <IonText color="primary">{item.name}</IonText>
                  </h5>
                  <IonText color="primary">
                    <IonIcon icon={documentTextOutline} style={countStyle}></IonIcon>{" "}
                    <span style={countStyle}>{item.documentCount}</span>{" "}
                    <IonIcon icon={personOutline} style={countStyle}></IonIcon>{" "}
                    <span style={countStyle}>{item.peopleCount}</span>
                  </IonText>
                </IonLabel>
                <IonLabel className="ion-hide-md-down" text-wrap>
                  <h3 style={{ fontWeight: 700 }}>
                    <IonText color="primary">{item.name}</IonText>
                  </h3>
                  <IonText color="primary">
                    <IonIcon icon={documentTextOutline} style={countStyle}></IonIcon>{" "}
                    <span style={countStyle}>{item.documentCount}</span>{" "}
                    <IonIcon icon={personOutline} style={countStyle}></IonIcon>{" "}
                    <span style={countStyle}>{item.peopleCount}</span>
                  </IonText>
                </IonLabel>
                <IonButton
                  expand="block"
                  fill="clear"
                  onClick={() => {
                    dispatch(setDeselectDocumentType(item));
                    dispatch(findTotalPeople());
                  }}
                  size="default"
                >
                  <IonIcon icon={trashOutline} />
                </IonButton>
              </IonItem>
            ))}
          {findDocumentTypesStatus === "pending" && (
            <p className="ion-text-center">
              <IonSpinner />
            </p>
          )}
        </IonList>
      </IonContent>
    </IonCard>
  );
};
